var map = {
	"./cutis/hospital.jpg": 62,
	"./cutis/logo.png": 333,
	"./dev/hospital.jpg": 25,
	"./dev/logo.png": 886,
	"./indo/hospital.jpg": 656,
	"./indo/logo.png": 867,
	"./lf/hospital.jpg": 623,
	"./lf/logo.png": 615,
	"./lhekm/hospital.jpg": 1,
	"./lhekm/logo.png": 14,
	"./mitera/hospital.jpg": 354,
	"./mitera/logo.png": 593,
	"./mosc/logo.png": 711,
	"./test/hospital.jpg": 18,
	"./test/logo.png": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 828;